import { NotificationActionTypes } from "../models";
import { INotificationState } from "../models/interfaces";
import { SHOW_NOTIFICATION, HIDE_NOTIFICATION } from "../types";

export default (state: INotificationState[] = [], action: NotificationActionTypes): INotificationState[] => {
    switch (action.type) {
        case SHOW_NOTIFICATION:
            return [...state, action.payload];
        case HIDE_NOTIFICATION:
            return state.filter((n, i) => i !== action.payload);
        default:
            return state;
    }
};
